import React, { useEffect, useState } from 'react'
import { enUsteKaydir, kaydirmayiDinle, sayfaKaydirmaY } from '../lib/kaydir'

export default function ScrollToTopV2() {
    const [visible, setVisible] = useState<boolean>(false);

    useEffect(() => {
        return kaydirmayiDinle(() => setVisible(sayfaKaydirmaY() > 300));
    }, []);

    const scrollToTop = enUsteKaydir;

    return (
        <button 
            type="button" 
            aria-label="Yukarı Kaydır" 
            className="ht-totop"
            onClick={scrollToTop}
            style={{ display: visible ? 'flex' : 'none' }}
        >
            <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M0 10L1.7625 11.7625L8.75 4.7875V20H11.25V4.7875L18.225 11.775L20 10L10 0L0 10Z" fill="currentColor" />
            </svg>
        </button>
    );
}
